var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTable",
        { staticClass: "unit-settings-table", attrs: { isCheckable: false } },
        [
          _c(
            "CompassTableHead",
            [
              _vm.editMode ? _c("CompassTableHeadCell") : _vm._e(),
              _vm._v(" "),
              _c("CompassTableHeadCell", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t.__("common.labels.value")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _vm.showUnitCode
                ? _c("CompassTableHeadCell", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t.__("common.labels.unit_code")) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "CompassTableHeadCell",
                { staticClass: "unit-settings-table__head--centered" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t.__("common.labels.default_unit")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.editMode ? _c("CompassTableHeadCell") : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SaasDraggable",
            {
              attrs: {
                dragClass: "unit-settings-table__row",
                isTable: true,
                disabled: !_vm.editMode,
                handle: ".unit-settings-table__drag-handle"
              },
              on: { input: _vm.handleSortUpdate },
              model: {
                value: _vm.localUnits,
                callback: function($$v) {
                  _vm.localUnits = $$v
                },
                expression: "localUnits"
              }
            },
            _vm._l(_vm.units, function(unitItem) {
              return _c(
                "CompassTableRow",
                {
                  key: unitItem.id + "-" + _vm.unit,
                  staticClass: "unit-settings-table__row"
                },
                [
                  _vm.editMode
                    ? _c(
                        "CompassTableBodyCell",
                        {
                          staticClass: "unit-settings-table__fixed-width-cell",
                          attrs: { width: 64 }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "unit-settings-table__drag-handle" },
                            [
                              _c("CompassIcon", {
                                attrs: {
                                  icon: "drag-and-drop",
                                  type: _vm.isEditable ? "primary" : "disabled"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "CompassTableBodyCell",
                    { attrs: { width: 220, maxWidth: "220px" } },
                    [
                      !_vm.editMode
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(unitItem.label) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _c(
                            "CompassFormItem",
                            {
                              attrs: {
                                label: "",
                                error: _vm.getLabelError(unitItem)
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: { error: !!_vm.getLabelError(unitItem) },
                                on: {
                                  focus: function($event) {
                                    _vm.unitFocused = unitItem.id
                                  },
                                  blur: function($event) {
                                    return _vm.getSuggestion(unitItem)
                                  },
                                  input: function($event) {
                                    return _vm.emptyCode(unitItem)
                                  }
                                },
                                model: {
                                  value: unitItem.label,
                                  callback: function($$v) {
                                    _vm.$set(unitItem, "label", $$v)
                                  },
                                  expression: "unitItem.label"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showUnitCode
                    ? _c(
                        "CompassTableBodyCell",
                        [
                          !_vm.editMode
                            ? [
                                unitItem.parameters && unitItem.parameters.code
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(unitItem.parameters.code) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "CompassTooltip",
                                      {
                                        attrs: {
                                          content: _vm.$t.__(
                                            "settings.units.unit_list.no_code.tooltip"
                                          ),
                                          arrow: false
                                        }
                                      },
                                      [
                                        _c("CompassIcon", {
                                          staticClass:
                                            "unit-settings-table__warning-icon",
                                          attrs: { icon: "warning-fill" }
                                        })
                                      ],
                                      1
                                    )
                              ]
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "unit-settings-table__suggestion-wrapper"
                                },
                                [
                                  _c(
                                    "CompassFormItem",
                                    {
                                      attrs: {
                                        label: "",
                                        error: _vm.getCodeError(unitItem)
                                      }
                                    },
                                    [
                                      _c("CompassInput", {
                                        staticClass:
                                          "unit-settings-table__code-input",
                                        attrs: {
                                          error: !!_vm.getCodeError(unitItem)
                                        },
                                        model: {
                                          value: unitItem.parameters.code,
                                          callback: function($$v) {
                                            _vm.$set(
                                              unitItem.parameters,
                                              "code",
                                              $$v
                                            )
                                          },
                                          expression: "unitItem.parameters.code"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !unitItem.parameters.code
                                    ? [
                                        _vm.showSuggestion(unitItem)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "unit-settings-table__suggestion"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/ressources/logged/img/icon/svg/wand.svg",
                                                    height: "20",
                                                    width: "20"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "typographies-paragraph-medium-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          unitItem._embed
                                                            .suggestion.code
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("CompassButton", {
                                                  attrs: {
                                                    label: _vm.$t.__(
                                                      "common.actions.apply"
                                                    ),
                                                    type: "tertiary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.applySuggestion(
                                                        unitItem.id
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm.unitLoading === unitItem.id
                                          ? _c("CompassLoader")
                                          : _vm.unitFocused !== unitItem.id
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "unit-settings-table__suggestion--empty typographies-paragraph-medium-regular"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t.__(
                                                        "settings.units.unit_list.no_suggestions"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "CompassTableBodyCell",
                    {
                      staticClass: "unit-settings-table__default-unit-cell",
                      attrs: { alignContent: "center" }
                    },
                    [
                      !_vm.editMode
                        ? _c(
                            "CompassTooltip",
                            {
                              attrs: {
                                content: _vm.$t.__(
                                  "settings.units.unit_list.default_unit.tooltip"
                                ),
                                disabled: !_vm.isNewUnit(unitItem.id),
                                arrow: false
                              }
                            },
                            [
                              _c("CompassRadio", {
                                staticClass:
                                  "unit-settings-table__default-unit",
                                attrs: {
                                  modelValue: "Default unit",
                                  disabled:
                                    !_vm.canEditUnit ||
                                    _vm.isNewUnit(unitItem.id),
                                  checked: _vm.unit === unitItem.id
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleDefaultUnitUpdate(
                                      unitItem.id
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editMode && _vm.unit === unitItem.id
                        ? _c("CompassIcon", {
                            staticClass:
                              "unit-settings-table__default-unit-check",
                            attrs: { icon: "success-circle-fill" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.editMode
                    ? _c(
                        "CompassTableBodyCell",
                        {
                          staticClass: "unit-settings-table__fixed-width-cell",
                          attrs: { width: 64 }
                        },
                        [
                          _c(
                            "CompassTooltip",
                            {
                              attrs: {
                                content: _vm.deleteButtonTooltipContent(
                                  unitItem.id
                                ),
                                disabled: _vm.isDeleteButtonEnabled(
                                  unitItem.id
                                ),
                                arrow: false
                              }
                            },
                            [
                              _c("CompassIconButton", {
                                attrs: {
                                  variant: "destructive",
                                  icon: "bin",
                                  disabled: !_vm.isDeleteButtonEnabled(
                                    unitItem.id
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeUnit(unitItem.id)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.editMode
        ? _c("AddUnitRow", { on: { addUnit: _vm.addUnit } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }